import { Accessory, GooseStage } from "@waddle/shared";

export const ACCESSORIES: Accessory[] = [
    {
        id: "top_hat",
        name: "Top Hat",
        description: "",
        cost: 50,
        category: "hat",
        unlockedAtStage: GooseStage.GOOSE,
        imageUrl: "/accessories/top_hat.png",
    },
    {
        id: "cowboy_hat",
        name: "Cowboy Hat",
        description: "",
        cost: 40,
        category: "hat",
        unlockedAtStage: GooseStage.GOOSE,
        imageUrl: "/accessories/cowboy_hat.png",
    },
    {
        id: "cowboy_hat_2",
        name: "UT Cowboy Hat",
        description: "",
        cost: 45,
        category: "hat",
        unlockedAtStage: GooseStage.GOOSE,
        imageUrl: "/accessories/cowboy_hat_2.png",
    },
    {
        id: "blue_beanie",
        name: "Blue Beanie",
        description: "",
        cost: 30,
        category: "hat",
        unlockedAtStage: GooseStage.GOOSE,
        imageUrl: "/accessories/blue_beanie.png",
    },
    {
        id: "ut_beanie",
        name: "UT Beanie",
        description: "",
        cost: 60,
        category: "hat",
        unlockedAtStage: GooseStage.GOOSE,
        imageUrl: "/accessories/ut_beanie.png",
    },
    {
        id: "aviators",
        name: "Aviators",
        description: "",
        cost: 35,
        category: "glasses",
        unlockedAtStage: GooseStage.GOOSE,
        imageUrl: "/accessories/aviators.png",
    },
    {
        id: "round_glasses",
        name: "Round Glasses",
        description: "",
        cost: 25,
        category: "glasses",
        unlockedAtStage: GooseStage.GOOSE,
        imageUrl: "/accessories/round_glasses.png",
    },
    {
        id: "green_scarf",
        name: "Green Scarf",
        description: "",
        cost: 40,
        category: "scarf",
        unlockedAtStage: GooseStage.GOOSE,
        imageUrl: "/accessories/green_scarf.png",
    },
    {
        id: "longhorn_necklace",
        name: "Longhorn Necklace",
        description: "",
        cost: 70,
        category: "necklace",
        unlockedAtStage: GooseStage.GOOSE,
        imageUrl: "/accessories/longhorn_necklace.png",
    },
    {
        id: "gold_chain",
        name: "Gold Chain",
        description: "",
        cost: 55,
        category: "necklace",
        unlockedAtStage: GooseStage.GOOSE,
        imageUrl: "/accessories/gold_chain.png",
    },
    {
        id: "pink_bow",
        name: "Pink Bow",
        description: "",
        cost: 30,
        category: "bow",
        unlockedAtStage: GooseStage.GOOSE,
        imageUrl: "/accessories/pink_bow.png",
    },
    {
        id: "blue_bow",
        name: "Blue Bow",
        description: "",
        cost: 30,
        category: "bow",
        unlockedAtStage: GooseStage.GOOSE,
        imageUrl: "/accessories/blue_bow.png",
    },
    {
        id: "bow_tie",
        name: "Bow Tie",
        description: "",
        cost: 35,
        category: "tie",
        unlockedAtStage: GooseStage.GOOSE,
        imageUrl: "/accessories/bow_tie.png",
    },
    {
        id: "ut_tie",
        name: "UT Tie",
        description: "",
        cost: 65,
        category: "tie",
        unlockedAtStage: GooseStage.GOOSE,
        imageUrl: "/accessories/ut_tie.png",
    },
];